// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getIndicesDummyData = () => {
    return {
        body: {
            Message: "Success",
            lstofindices: [
                {
                    Exch: "N",
                    ExchType: "C",
                    IndexName: "Nifty 50",
                    ScripCode: "999920000",
                },
                {
                    Exch: "N",
                    ExchType: "C",
                    IndexName: "BANKNIFTY",
                    ScripCode: "999920005",
                },
            ],
            status: "0",
        },
        head: {
            responseCode: "5PGetInd",
            status: "0",
            statusDescription: "Success",
        },
    };
};
